module.exports = __webpack_public_path__ + "images/branding/manpower/logged_out.gif";